var exports = {
  "Wl": "EmbedGifv.module__imagePreviewHandler___elBhdW",
  "tN": "EmbedGifv.module__blurContainer___elBhdW",
  "rj": "EmbedGifv.module__blurContent___elBhdW",
  "JV": "EmbedGifv.module__blurInnerContainer___elBhdW",
  "aO": "EmbedGifv.module__thumbHashPlaceholder___elBhdW",
  "il": "EmbedGifv.module__mediaContainer___elBhdW",
  "M_": "EmbedGifv.module__videoWrapper___elBhdW",
  "UD": "EmbedGifv.module__videoElement___elBhdW",
  "qf": "EmbedGifv.module__placeholder___elBhdW",
  "ci": "EmbedGifv.module__placeholderFastFade___elBhdW",
  "Ap": "EmbedGifv.module__placeholderVisible___elBhdW",
  "uR": "EmbedGifv.module__placeholderHidden___elBhdW",
};

module.exports = exports;
